import { fetchTopics } from '../services/topics';
import { SET_COURSE_TOPICS } from './types';

export const getTopics = ({ classId, topicIds }) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      fetchTopics({ classId, topicIds })
        .then(({ list, count }) => {
          dispatch({
            type: SET_COURSE_TOPICS,
            list,
            count
          });

          resolve(list);
        })
        .catch((error) => {
          reject(error);
          console.error(`getTopics: ${error}`);
        });
    });
  };
};
